const dinamicSidebar = {
    wrap: document.getElementById('dinamicSidebarWrap') as HTMLElement,
    nav: document.getElementById('dinamicSidebar') as HTMLElement,
    sections: document.querySelectorAll('.jsSection') as NodeListOf<HTMLElement>,
    links: document.querySelectorAll('.jsSectionLink') as NodeListOf<HTMLElement>,
    cartLine: document.getElementById('addToCartLine') as HTMLElement,

    init() {
        if (this.wrap) {
            this.setWrap();        
            this.scrollToSec();
        }


    },
    scrollToSec() {
        this.links.forEach(item => {
            const link = item.firstElementChild as  HTMLLinkElement;
            const secId = link.dataset.href as string;
            const section = document.getElementById(secId) as HTMLElement;
         
            const scroll = section.getBoundingClientRect().top + window.scrollY - 200
            link.addEventListener('click', (e)=>{
            
                window.scroll({
                    top: scroll,
                    behavior: 'smooth'
                  });
            })
        })
    },
    isInView(el: HTMLElement) {
    
        const rect = el.getBoundingClientRect(); 
        return rect.top <= 40 ;
    },

    setWrap() {
        document.addEventListener('scroll', (e) => {
            const top = this.wrap.getClientRects()[0].top

            if (top < 0) {
                this.nav.classList.add('activeClass');
                this.cartLine.classList.add('activeClass');
            } else {
                this.nav.classList.remove('activeClass');
                this.cartLine.classList.remove('activeClass');
            }
            this.sections.forEach((item, index) => {
                const currentLink = this.links[index];
                if(this.isInView(item) &&  !currentLink.classList.contains('activeLink')){
               
                    this.links.forEach(item => {
                        item.classList.remove('activeLink')
                    })
                    currentLink.classList.add('activeLink')
                    const left = currentLink.getBoundingClientRect().left
                    this.nav.scroll({                      
                        left: left                      
                      });
                }
              
            })
        },{passive: true} )

    },


}

export default dinamicSidebar;